/**
 * Created by AbdulRehman on 3/3/2016.
 */

(function () {

    angular.module('tmx-app')
        .controller('ApplicationsDialogController', ['$scope', '$state','LoanApplicationService','$mdDialog','action', 'tmxUtility',


            function ApplicationsDialogController($scope, $state, LoanApplicationService,$mdDialog,action,tmxUtility) {
        //$scope.$broadcast('init-map');

                var vm=this;
                vm.service = LoanApplicationService;
                vm.query = "Company";
        // vm.gridData = new kendo.data.ObservableArray(value);

                vm.date = new Date().toJSON();
                vm.formatDate=tmxUtility.formatDateForCompany;
        //vm.cols = LoanApplicationService.filterColumn;
        //vm.nav = "SearchSideNav";
        //vm.schema = LoanApplicationService.schema;
        // vm.cloneColumn = LoanApplicationService.gridColumn;
        //vm.LoanApplicationService = LoanApplicationService;


        //*************Functions****************
                vm.reload=function(){
                    vm.container.companyGrid.dataSource.read();
                }

                vm.success=function(promise){
                    if(promise.read==true) {
                        vm.container.companyGrid.dataSource.transport.read(promise);
                    }
                    else {
                        vm.container.companyGrid.dataSource.read();
                    }
                    vm.toggle(vm.nav);
                };
                vm.isFiltered=function(fieldName){
                    var filtered = false;
                    if(fieldName=="Status"){
                        fieldName="EffectiveEndDate";
                    }
                    if(angular.isDefined(vm.filters)) {
                        vm.filters.filters.forEach(function(filter){
                            if(filter.field==fieldName)
                                filtered = true;
                        });
                    }
                    return filtered;
                }
                vm.onChildState=function(){
            // if($state.current.name.indexOf(".add")>0 || $state.current.name.indexOf(".edit")>0) return true;
                }

                vm.isOpen = function() {
            // return $mdSidenav(navID).isOpen();
                };

                vm.newLoanApplication = function(){
                    $state.go("private.transaction.loanapplication.add",{callbackState:"private.inbox"});
                };

                vm.clickEdit = function () {
            // $state.data.info = false;
            // $state.go($state.current.name+".edit",{"Id":item.CompanyId});
                }


                vm.clickView = function () {
            // $state.data.info = true;
            // $state.go($state.current.name+".edit",{"Id":item.CompanyId});
                }


//*******************Kendo row template functions****************************

                vm.dataObj ={
                    value: "empty"}

                vm.isStatusActive=function(dataitem){
                    if(dataitem.EffectiveEndDate<vm.date)return true;
                    return false;
                }

                vm.status=function(dataitem){
                    if(dataitem.EffectiveEndDate<vm.date) {
                        return "Inactive";
                    }
                    return "Active";
                }

                vm.goToLAEdit=function(){
            // $state.go("private.transaction.loanapplication.edit",{Id:id,callbackState:$state.current.name});
                }

//*******************KENDO*********************//
                var culture=kendo.culture();

                culture.numberFormat.currency.symbol = "PKR. ";               
                vm.formatId=function(item){
                    var id=item.LoanApplicationId;
                    var template='<md-button class="md-primary">'+id+'</md-button>';
                    return template;
                }
                vm.makeProcessId=function(item){
                    return item.LoanApplicationId+'-'+item.LoanType;
                }

                vm.gridColumns =[
                    {
                        field: "LoanApplicationId",
                        title: "Loan Application Id",
                        template:vm.formatId,
                        type: "numeric",
                        search: true
                    },
                    {
                        title: "Process Instance Name",
                        search: true,
                        template:vm.makeProcessId
                    },
                    {
                        field:"ActivityName",
                        title: "Activity Name",
                        type: "string",
                        search: true
                    },
                    {
                        field:"LoanType",
                        title: "Loan Type",
                        type: "string",
                        search: true,
                    },
                    {
                        field:"RequestedLoanAmount",
                        title: "Requested Loan Amount",
                        format: "{0:c}",
                        type: "currency",
                        search: true,
                    },
                    {
                        field:"Creator",
                        title: "Creator",
                        type: "string",
                        search: true,
                    },
                    {
                        field:"Status",
                        title:"Status",
                        type: "string",
                        search: true,
                    },
                    {
                        field:"LoanApplicationDate",
                        title:"Created Date",
                        template:vm.formatDate
                    }
                ];

                vm.mainGridOptions = {
                    dataSource: {
                        transport: {
                            read: function(o){
                        // LoanApplicationService.getByAction("",true).then(function(response){
                                vm.service.getByParams(o,true,action).then(function(response){
                                    o.success(response);

                                });
                            },

                            dataType: "json"
                        },
                        schema: {
                            data: "data",
                            total: "Total"
                        },
                        serverPaging: true,
                        serverFiltering: true,
                        serverSorting: true,
                    },
            //data:vm.gridData,
                    filterable: true,
                    scrollable: false,
                    sortable: true,
                    selectable: "row",
                    pageable: {
                        refresh: true,
                        pageSizes: true,
                        pageSize: 10,
                        buttonCount: 5
                    },
                    columns: vm.gridColumns
                };

                vm.container = {};
                $state.data={
                    grid: vm.container,
                    info: false
                };


                $scope.hide = function() {
                    $mdDialog.hide();
                };
                $scope.cancel = function() {
                    $mdDialog.cancel();
                };
                $scope.answer = function(answer) {
                    $mdDialog.hide(answer);
                };
            }]);
})();
